module.exports = __webpack_public_path__ + "static/media/ggc.536ed45f.webp";